import React from 'react'
import { Text } from 'react-form'
import {Form, Col, FormGroup, Button, ControlLabel, Row, OverlayTrigger, Tooltip} from 'react-bootstrap'
import {MdVisibility, MdVisibilityOff} from '../Common/ReactIcons/icons'

export default ({values, submitForm, setValue, disabled, message}) => {
  function togglePasswordView () {
    let showPasswordIcon = (!values.showPasswordIcon)
    let type = (values.showPasswordIcon) ? 'text' : 'password'
    setValue('showPasswordIcon', showPasswordIcon)
    setValue('type', type)
  }

  const tooltipShow = (
    <Tooltip id="tooltip">نمایش رمز عبور</Tooltip>
  )
  const tooltipHide = (
    <Tooltip id="tooltip">مخفی کردن رمز عبور</Tooltip>
  )

  return (
    <Form horizontal onSubmit={submitForm}>
      <Row className="FormWrapper">
        <Col xs={4} xsOffset={4} className="Box">

          <h1 className="FormTitle">تغییر رمز عبور</h1>
          {message.context && <div className={`alert alert-${message.status}`}>{message.context}</div>}

          <FormGroup>
            <Col componentClass={ControlLabel} xs={4} >
              رمز عبور جدید
            </Col>
            <Col xs={7}>
              <Text
                field="new_password"
                type={values.type}
                className="form-control"
              />
              <div onClick={togglePasswordView} className="password-visibility-icon">
                <OverlayTrigger placement="top" overlay={tooltipShow}>
                  <MdVisibility className={!values.showPasswordIcon && 'hide'} />
                </OverlayTrigger>
                <OverlayTrigger placement="top" overlay={tooltipHide}>
                  <MdVisibilityOff className={values.showPasswordIcon && 'hide'} />
                </OverlayTrigger>
              </div>
            </Col>
          </FormGroup>

          <FormGroup>
            <Col xsOffset={4} xs={7}>
              <Button type="submit" className="btnBlock" bsStyle="success" disabled={disabled}>
                تغییر
              </Button>
            </Col>
          </FormGroup>

        </Col>
      </Row>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./src/components/ResetPassword/ResetPasswordForm.js